import React from "react";
import GAContentDetailsContainer from "../../modules/GAContentModeration/containers/GAContentDetailsContainer/GAContentDetailsContainer";

const GAContentModerationDetails = () => {
  return <GAContentDetailsContainer />;
};

export default GAContentModerationDetails;
